// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/scripts/" + {"18":"ffac01fc413aeedb3544","194":"95f815fa1fa72fb62e44","495":"ae3fed0a1b85fcd80546","835":"f2df99288ece822a7a7a"}[chunkId] + ".chunk.js";
};